import React from "react"

type Props = {
    className?  : string,
    params      : any
}

export default class ModalV4 extends React.Component<any, any> {

    stopPropagation = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    closeModal = () => {
        gd.modal.hide()
    }

    render(): any {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                Content here
            </div>
        )
    }
}
